export default '/frontend/';
export const RELATIVE_URL = '/ui/';
